// extracted by mini-css-extract-plugin
module.exports = {"container":"i_QW","icon":"i_QX","simple":"i_QY","label":"i_QZ","embedded":"i_Qa"};